import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './comissaoOperacaoForm';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';

import { 
	setModoTela, initForm, salvar, excluir, getLista, setFiltro,
	getListaOperacao, getListaComissaoTermo, getListaComissaoVinculo, 
	getListaUsuario, getListaComissaoTipo
} from './comissaoOperacaoActions';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class ComissaoOperacao extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaOperacao();
		this.props.getListaComissaoTermo();
		this.props.getListaComissaoVinculo();
		this.props.getListaUsuario();
		this.props.getListaComissaoTipo();
    }

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
		
		const semOutrosFiltros = !this.props.filtro.id_operacao
			&& !this.props.filtro.id_termo
			&& !this.props.filtro.id_colaborador
			&& !this.props.filtro.id_tipo;

		let lista = this.props.lista.map(item => ({ ...item }));
		if (semOutrosFiltros) {
			for (let i = 0; i < this.props.listaOperacao.length; i++) {
				const operacao = this.props.listaOperacao[i];
			
				if (!lista.filter(item => item.id_operacao == operacao.id).length) {
					lista.push({
						...operacao,
						id: null
					});
				}
			}
		}

		if (this.props.filtro.id_status == 1) { //Todas
			//Lista todas
		} else if (this.props.filtro.id_status == 2) { //Operações com termo vigente
			lista = lista.filter(item => item.vigente);
		} else if (this.props.filtro.id_status == 3) { //Operações com termo vencido
			lista = lista.filter(item => item.data_inicio && !item.vigente);
		} else if (this.props.filtro.id_status == 4) { //Operações novas
			lista = lista.filter(item => item.registroOperacao);
		} else if (this.props.filtro.id_status == 5) { //Operações ativas
			lista = lista.filter(item => item.operacao_ativo);
		} else if (this.props.filtro.id_status == 6) { //Operações inativas
			lista = lista.filter(item => !item.operacao_ativo);
		}

		lista = lista.filter(item => {

			if (this.state.pesquisar
				&& !(`		
					${item.nome_operacao}
					${DateFormat.formatarDataSqlParaTela(item.data_inicio)} ${DateFormat.formatarDataSqlParaTela(item.data_fim)}
					${item.nome_termo} ${item.nome_vinculo} ${item.nome_colaborador} ${item.nome_tipo}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardBody>

					<Row>
						<LabelAndInputMask
							label='Data' placeholder='Informe a data'
							cols='12 6 2 1'
							mask='99/99/9999'
							minWidth={130}
							maxWidth={130}
							value={this.props.filtro.data}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data: data.target.value });
							}} />

						<Select
							options={this.props.listaComissaoVinculo}
							label='Vínculo'
							cols='12 6 4 3'
							placeholder='Selecione o vínculo'
							maxWidth={250}
							value={this.props.filtro.id_vinculo}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, id_vinculo: value });
							}} />

						<Select
							options={this.props.listaComissaoTermo}
							label='Termo'
							cols='12 6 4 3'
							placeholder='Selecione o termo'
							maxWidth={250}
							value={this.props.filtro.id_termo}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, id_termo: value });
							}} />
						
						<Select
							options={this.props.listaComissaoTipo}
							label='Tipo'
							cols='12 6 4 3'
							placeholder='Selecione o tipo'
							value={this.props.filtro.id_tipo}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, id_tipo: value });
							}} />

						<Select
							options={this.props.listaOperacao}
							label='Operação'
							cols='12 6 4 3'
							placeholder='Selecione a operação'
							value={this.props.filtro.id_operacao}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, id_operacao: value });
							}} />

						<Select
							options={this.props.listaUsuario}
							label='Colaborador'
							cols='12 6 4 3'
							placeholder='Selecione o colaborador'
							value={this.props.filtro.id_colaborador}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, id_colaborador: value });
							}} />

						<Select
							options={[
								{ id: 1, valor: 'Todas' },
								{ id: 2, valor: 'Operações com termo vigente' },
								{ id: 3, valor: 'Operações com termo vencido' },
								{ id: 4, valor: 'Operações novas' },
								{ id: 5, valor: 'Operações ativas' },
								{ id: 6, valor: 'Operações inativas' }
							]}
							label='Status'
							cols='12 6 4 3'
							placeholder='Selecione o status'
							maxWidth={300}
							value={this.props.filtro.id_status}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, id_status: value });
							}} />

						
						<div style={{ marginTop: 8 }}>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<ExcelFile
								filename={'Acessórios - Saída'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									operacao_data_inclusao: DateFormat.formatarDataSqlParaTela(item.operacao_data_inclusao),
									data_base: DateFormat.formatarDataSqlParaTela(item.data_base),
									data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
									data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim),
									conquista_integral: parseFloat(item.conquista_integral),
									conquista_30_60: parseFloat(item.conquista_30_60),
									conquista_mais_60: parseFloat(item.conquista_mais_60),
									manutencao_integral: parseFloat(item.manutencao_integral),
									manutencao_30_60: parseFloat(item.manutencao_30_60),
									manutencao_mais_60: parseFloat(item.manutencao_mais_60)
								}))} name='Comissão - Operação'>
									<ExcelColumn label='Código Operação' value='codigo_operacao' />
									<ExcelColumn label='Nome Operação' value='nome_operacao' />
									<ExcelColumn label='Data Cadastro' value='operacao_data_inclusao' />
									<ExcelColumn label='Negociador' value='operacao_nome_negociador' />
									<ExcelColumn label='Ativa' value='operacao_ativo' />
									<ExcelColumn label='Data Base' value='data_base' />
									<ExcelColumn label='Início Vigência' value='data_inicio' />
									<ExcelColumn label='Fim Vigência' value='data_fim' />
									<ExcelColumn label='Termo' value='nome_termo' />
									<ExcelColumn label='Vínculo' value='nome_vinculo' />
									<ExcelColumn label='Colaborador' value='nome_colaborador' />
									<ExcelColumn label='Tipo' value='nome_tipo' />
									<ExcelColumn label='Conquista (Integral)' value='conquista_integral' type='number' />
									<ExcelColumn label='Conquista (30 até 60)' value='conquista_30_60' type='number' />
									<ExcelColumn label='Conquista (Mais de 60)' value='conquista_mais_60' type='number' />
									<ExcelColumn label='Manutenção (Integral)' value='manutencao_integral' type='number' />
									<ExcelColumn label='Manutenção (30 até 60)' value='manutencao_30_60' type='number' />
									<ExcelColumn label='Manutenção (Mais de 60)' value='manutencao_mais_60' type='number' />
								</ExcelSheet>											
							</ExcelFile>

							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro');
									this.props.initForm({});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>
							
						</div>
					</Row>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />

					<Table responsive border>
						<THead>
							<Tr>
								<Th rowspan={2} alignCenter>Operação</Th>
								<Th rowspan={2} alignCenter>Cadastro</Th>
								<Th rowspan={2} alignCenter>Negociador</Th>
								<Th rowspan={2} alignCenter>Ativa</Th>
								<Th rowspan={2} alignCenter>Data Base</Th>
								<Th rowspan={2} alignCenter>Início Vigência</Th>
								<Th rowspan={2} alignCenter>Fim Vigência</Th>
								<Th rowspan={2} alignCenter>Termo</Th>
								<Th rowspan={2} alignCenter>Vínculo</Th>
								<Th rowspan={2} alignCenter>Colaborador</Th>
								<Th rowspan={2} alignCenter>Tipo</Th>
								<Th colspan={3} alignCenter>Conquista</Th>
								<Th colspan={3} alignCenter>Manutenção</Th>
								<Th rowspan={2} width={60}></Th>
							</Tr>
							<Tr>
								<Th alignCenter>Integral</Th>
								<Th alignCenter>30 até 60</Th>
								<Th alignCenter>Mais de 60</Th>
								<Th alignCenter>Integral</Th>
								<Th alignCenter>30 até 60</Th>
								<Th alignCenter>Mais de 60</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.registroOperacao ? `OP-${item.id_operacao}` : item.id} className={`${this.state.linhaSelecionada == (item.registroOperacao ? `OP-${item.id_operacao}` : item.id) ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.registroOperacao ? `OP-${item.id_operacao}` : item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.registroOperacao ? `OP-${item.id_operacao}` : item.id })} >
									<Td alignCenter small>{item.codigo_operacao} - {item.nome_operacao}</Td>
									<Td alignCenter small>{DateFormat.formatarDataSqlParaTela(item.operacao_data_inclusao)}</Td>
									<Td alignCenter small>{item.operacao_nome_negociador}</Td>
									<Td alignCenter small>{item.operacao_ativo ? 'Ativa' : 'Inativa'}</Td>
									<Td alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_base)}</Td>
									<Td alignCenter small backgroundColor={item.vigente ? '#00750a' : '#a33600'} color={'#ffffff'}>{DateFormat.formatarDataSqlParaTela(item.data_inicio)}</Td>
									<Td alignCenter small backgroundColor={item.vigente ? '#00750a' : '#a33600'} color={'#ffffff'}>{DateFormat.formatarDataSqlParaTela(item.data_fim)}</Td>
									<Td alignCenter small>{item.nome_termo}</Td>
									<Td alignCenter small>{item.nome_vinculo}</Td>
									<Td alignCenter small>{item.nome_colaborador}</Td>
									<Td alignCenter small>{item.nome_tipo}</Td>
									<Td alignCenter small>{FormatUtils.formatarValorTela(item.conquista_integral, 3)}</Td>
									<Td alignCenter small>{FormatUtils.formatarValorTela(item.conquista_30_60, 3)}</Td>
									<Td alignCenter small>{FormatUtils.formatarValorTela(item.conquista_mais_60, 3)}</Td>
									<Td alignCenter small>{FormatUtils.formatarValorTela(item.manutencao_integral, 3)}</Td>
									<Td alignCenter small>{FormatUtils.formatarValorTela(item.manutencao_30_60, 3)}</Td>
									<Td alignCenter small>{FormatUtils.formatarValorTela(item.manutencao_mais_60, 3)}</Td>
									<Td minWidth={80} alignRight small>
										{(item.registroOperacao || !item.vigente) && 
										<ButtonTable
											type={'success'}
											icon={'fas fa-plus'}
											visible={this.state.linhaSelecionada == (item.registroOperacao ? `OP-${item.id_operacao}` : item.id)}
											small
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													id: null,
													data_inicio: null,
													data_fim: null
												});
												this.props.initForm({
													...item,
													id: null,
													data_inicio: null,
													data_fim: null
												});
											}}
											title='Adicionar nova vigência' />}

										{(item.id != null && !item.registroOperacao) &&
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == (item.registroOperacao ? `OP-${item.id_operacao}` : item.id)}
											small
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													data_base: DateFormat.formatarDataSqlParaTela(item.data_base),
													data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
													data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim)
												});
												this.props.initForm({
													...item,
													data_base: DateFormat.formatarDataSqlParaTela(item.data_base),
													data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
													data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim)
												});
											}}
											title='Alterar vigência do termo' />}

										{(item.id != null && !item.registroOperacao) &&
										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == (item.registroOperacao ? `OP-${item.id_operacao}` : item.id)}
											small
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													data_base: DateFormat.formatarDataSqlParaTela(item.data_base),
													data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
													data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim)
												});
												this.props.initForm({
													...item,
													data_base: DateFormat.formatarDataSqlParaTela(item.data_base),
													data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
													data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim)
												});
											}}
											title='Excluir termo' />}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.comissaoOperacao.modoTela,
	filtro: state.comissaoOperacao.filtro,
	aguardando: state.comissaoOperacao.aguardando,
	lista: state.comissaoOperacao.lista,
	listaOperacao: state.comissaoOperacao.listaOperacao,
	listaComissaoVinculo: state.comissaoOperacao.listaComissaoVinculo,
	listaComissaoTermo: state.comissaoOperacao.listaComissaoTermo,
	listaUsuario: state.comissaoOperacao.listaUsuario,
	listaComissaoTipo: state.comissaoOperacao.listaComissaoTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, setFiltro,
	getListaOperacao, getListaComissaoTermo, getListaComissaoVinculo, 
	getListaUsuario, getListaComissaoTipo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ComissaoOperacao);
